<template>
  <div v-if="charge && ((!isShow && charge[1]) || isShow)" class="mb-2">
    <div v-if="loading" class="spinner text-xs-center">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>
    <div v-else class="z-border-red pa-2">
      <v-layout>
        <v-flex>
          <img
            :src="
              '/static/img/assets/payment/' +
                (name.includes('other') ? 'other_charge' : name) +
                '_logo.png'
            "
            alt
            style="height: 50px; object-fit: contain; width: 85px; vertical-align: middle;"
            class="mr-2 mb-2"
          />
          <div class="clearfix hidden-sm-and-up"></div>
          <template v-if="name.includes('other')">{{ otherName }}</template>
          <template v-else>{{ $t(name) }}</template>
        </v-flex>
        <v-flex class="text-xs-right">
          <template v-if="isEdit">
            <toggle-button
              class="mt-2"
              :value="chargeStatus"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="onChangeStatus"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </template>
          <template v-else>
            <v-chip v-if="chargeStatus" color="green" class="white--text" small disabled>{{
              $t('active')
            }}</v-chip>
            <v-chip v-else color="red" class="white--text" small disabled>{{
              $t('inactive')
            }}</v-chip>
          </template>

          <span @click="isEdit = !isEdit" style="cursor: pointer" v-if="!isEdit">
            <v-btn fab outline small color="primary">
              <v-icon>edit</v-icon>
            </v-btn>
          </span>
        </v-flex>
      </v-layout>
      <div v-show="isEdit">
        <v-divider class="mb-3"></v-divider>
        <template v-if="isEdit && name.includes('other')">
          <div class="form-control">
            <div class="caption">{{ $t('Shipping Name') }}</div>
            <input type="text" maxlength="255" v-model="charge[4]" />
          </div>
        </template>
        <template v-if="name != 'additionalproduct_charge'">
          <v-layout wrap>
            <v-flex xs12 sm3 full-height class="form-control pa-1 border-right">
              <div class="caption">{{ $t('Shipping Fee (Standard)') }}</div>
              <template v-if="isEdit">
                <template
                  v-if="['111255290641275', '998122266996445'].includes(selectedBot.pageid)"
                >
                  <input type="text" v-model="charge[0]" maxlength="100" />
                </template>
                <input
                  v-else
                  type="number"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  v-model="charge[0]"
                />
              </template>
              <div class="primary--text" v-else-if="charge[0] != 0 && isNumber(charge[0])">
                ฿{{ charge[0] | decimalFormat }}
              </div>
              <div class="primary--text" v-else-if="charge[0] != 0">{{ charge[0] }}</div>
              <div class="primary--text" v-else>{{ $t('Free') }}</div>
            </v-flex>
            <v-flex xs12 sm9 class="pa-1 pb-3">
              <div class="caption">{{ $t('Shipping Fee (Weight-based)') }} ({{ $t('gram') }})</div>
              <template v-if="charge[2].length > 0">
                <template v-for="(weight, index) in charge[2]">
                  <shipping-detail-weight
                    :position="index"
                    v-model="charge[2][index]"
                    :key="'weight_' + index + '_' + timestamp"
                    :isEdit="isEdit"
                    :minWeight="
                      index > 0
                        ? charge[2][index - 1].max
                          ? parseFloat(charge[2][index - 1].max)
                          : 0
                        : null
                    "
                    :lastPrice="
                      index > 0
                        ? charge[2][index - 1].price
                          ? parseFloat(charge[2][index - 1].price)
                          : 0
                        : 0
                    "
                    @onChangeValue="onChangeValue"
                    @onDelete="onDeleteShippingWeight(index)"
                  ></shipping-detail-weight>
                </template>
              </template>
              <div class="primary--text pa-1" v-else-if="charge[2].length == 0 && !isEdit">
                {{ $t('No Weight-based delivery') }}
              </div>
              <div
                class="btn-add text-xs-center"
                v-if="isEdit"
                style="cursor: pointer"
                @click="addShippingWeight"
              >
                <v-icon class="mr-1" style="verticle-align: middle">add</v-icon>
                {{ $t('Add') }}
              </div>
            </v-flex>
            <v-flex sm12>
              <v-divider />
            </v-flex>
            <v-flex v-if="isEdit" xs12 :sm6="name == 'cod_charge'" class="pt-3 pl-1">
              <div class="form-control">
                <label>{{ $t('Additional Charge per item') }}</label>
                <div v-if="isEdit">
                  <input type="number" v-model.number="charge[3]" />
                </div>
                <div v-else class="primary--text">
                  {{ charge[3] }}
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 v-if="name == 'cod_charge'" class="pt-3 pl-1">
              <label>{{ $t('Shipping Fee (Percent)') }}</label>
              <div class="form-control" v-if="isEdit">
                <v-layout>
                  <v-flex>
                    <input
                      type="number"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      min="0"
                      max="100"
                      v-model="percentCharge"
                      @blur="onBlurNumber"
                    />
                  </v-flex>
                  <v-flex shrink class="pa-2"> % </v-flex>
                </v-layout>
              </div>
              <div class="primary--text" v-else>{{ charge[4] ? charge[4] : '-' }}</div>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <div class="form-control pa-1">
            <div class="caption">{{ $t('shipping fee') }}</div>
            <template v-if="isEdit">
              <input type="text" pattern="[0-9]*" inputmode="numeric" v-model="charge[0]" />
            </template>
            <div class="primary--text" v-else-if="charge[0] != 0">
              ฿{{ charge[0] | decimalFormat }}
            </div>
            <div class="primary--text" v-else>{{ $t('Free') }}</div>
          </div>
        </template>
        <template
          v-if="
            [
              'kerry_charge',
              'flash_charge',
              'jtexpress_charge',
              'bestexpress_charge',
              'cjlogistics_charge',
              'ninjavan_charge',
              'scgexpress_charge'
            ].includes(name)
          "
        >
          <div class="text-xs-center mt-3">
            <a
              class="text btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
              style="position: relative"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
              ></i>
            </a>
          </div>
          <template v-if="showAdvanced">
            <v-layout wrap class="mt-3">
              <v-flex xs12 sm6 md4 class="form-control pa-1">
                <div class="caption">{{ $t('Shipping Fee (surrounding)') }}</div>
                <template v-if="isEdit">
                  <input type="number" pattern="[0-9]*" inputmode="numeric" v-model="charge[5]" />
                </template>
                <div class="primary--text" v-else>{{ charge[5] ? charge[5] : '-' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 class="form-control pa-1">
                <div class="caption">{{ $t('Shipping Fee (up-country)') }}</div>
                <template v-if="isEdit">
                  <input type="number" pattern="[0-9]*" inputmode="numeric" v-model="charge[6]" />
                </template>
                <div class="primary--text" v-else>{{ charge[6] ? charge[6] : '-' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 class="form-control pa-1">
                <div class="caption">{{ $t('Shipping Fee (remote area)') }}</div>
                <template v-if="isEdit">
                  <input type="number" pattern="[0-9]*" inputmode="numeric" v-model="charge[7]" />
                </template>
                <div class="primary--text" v-else>{{ charge[7] ? charge[7] : '-' }}</div>
              </v-flex>
            </v-layout>
          </template>
          <br />
        </template>
        <v-divider />

        <div style="display: flex; justify-content: space-between; align-items: flex-start">
          <div class="caption pa-1">
            {{
              $t(
                'Note: Total Shipping Fee will be included Shipping Fee (Standard) and Shipping Fee (Weight-based)'
              )
            }}
          </div>
        </div>
      </div>
      <v-flex>
        <v-layout wrap style="align-items: center;">
          <v-flex xs12 sm6>
            <v-chip
              color="success"
              small
              class="white--text text-xs-left"
              disabled
              v-if="
                [
                  'kerry_charge',
                  'flash_charge',
                  'jtexpress_charge',
                  'bestexpress_charge',
                  'cjlogistics_charge',
                  'ninjavan_charge',
                  'scgexpress_charge'
                ].includes(name)
              "
            >
              {{ $t('Able to apply additional fee in remote area') }}
            </v-chip>
            <v-chip
              color="red"
              small
              class="white--text"
              disabled
              v-if="selectedBot.shippop_status == true && ['nikos_charge'].includes(name)"
            >
              ไม่รองรับการขนส่งผ่านระบบ Shippop
            </v-chip>
            <v-chip
              color="info"
              small
              class="white--text"
              disabled
              :key="'packhai_' + charge.name"
              v-if="
                selectedBot.packhai_status == true &&
                  [
                    'bestexpress_charge',
                    'kerry_charge',
                    'ems_charge',
                    'nim_charge',
                    'flash_charge',
                    'scgexpress_charge',
                    'jtexpress_charge',
                    'cod_charge'
                  ].includes(name)
              "
              >รองรับการขนส่งผ่านระบบ Packhai</v-chip
            >
            <v-chip
              color="info"
              small
              class="white--text"
              disabled
              :key="'sokochan_' + charge.name"
              v-if="
                selectedBot.sokochan_info &&
                  selectedBot.sokochan_info.status &&
                  [
                    'normal_charge',
                    'kerry_charge',
                    'kerry1d_charge',
                    'kerry2d_charge',
                    'ems_charge',
                    'cod_charge'
                  ].includes(name)
              "
              >รองรับการขนส่งผ่านระบบ Sokochan</v-chip
            >
            <v-chip
              color="info"
              small
              class="white--text"
              disabled
              :key="'zortout_' + charge.name"
              v-if="
                selectedBot.zortout_is_active &&
                  [
                    'jtexpress_charge',
                    'flash_charge',
                    'kerry_charge',
                    'kerry1d_charge',
                    'kerry2d_charge',
                    'normal_charge',
                    'ems_charge',
                    'cjlogistics_charge',
                    'ninjavan_charge'
                  ].includes(name)
              "
              >รองรับการขนส่งผ่านระบบ Zortout</v-chip
            >
          </v-flex>
          <v-flex xs12 sm6>
            <div class="text-xs-right">
              <div v-if="isEdit">
                <v-btn color="grey" outline @click="isEdit = false">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn color="primary" depressed @click="saveContent">
                  {{ $t('Save') }}
                </v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import ShippingDetailWeight from './ShippingDetailWeight'
import dayjs from 'dayjs'
import { ToggleButton } from 'vue-js-toggle-button'
import { cloneDeep } from 'lodash'
export default {
  props: ['value', 'isShow', 'name', 'charges'],
  inject: ['$validator'],
  data: function() {
    return {
      charge: this.value,
      isEdit: false,
      chargeType: 'normal',
      percentCharge: 0,
      timestamp: dayjs().format('x'),
      showAdvanced: false,
      loading: false,
      chargeStatus: false
    }
  },

  components: {
    ShippingDetailWeight,
    ToggleButton
  },
  mounted() {
    if (this.charge && this.charge[1]) {
      this.chargeStatus = this.charge[1]
    }
    if (this.name == 'cod_charge') {
      if (this.charge && this.charge[4] != '') {
        this.chargeType = 'percent'
        var percent = this.charge[4]
        try {
          percent = percent.replace('%', '')
          percent = parseInt(percent)
          this.percentCharge = percent
        } catch (error) {
          percent = 0
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    otherName() {
      if (!this.charge) return ''
      if (this.charge[4] && this.charge[4].includes('Other')) {
        if (this.charge[4].match(/\d+/g)) {
          return this.$t('other_charge') + ' ' + this.charge[4].match(/\d+/g).map(Number)[0]
        } else {
          return this.$t('other_charge')
        }
      } else {
        return this.charge[4]
      }
    }
  },
  methods: {
    onChangeValue() {
      this.timestamp = dayjs().format('x')
    },
    onBlurNumber(el) {
      try {
        if (el.target) {
          var number = parseInt(el.target.value)
          if (number < 0) {
            el.target.value = 0
          } else if (number > 100) {
            el.target.value = 100
          }
        }
      } catch (error) {
        el.target.value = 0
      }

      this.$set(this.charge, 4, el.target.value ? el.target.value + '%' : '')
      this.$emit('input', this.charge)
    },
    onChangeStatus() {
      this.chargeStatus = !this.chargeStatus
    },
    addShippingWeight() {
      this.charge[2].push({ min: null, max: null, charge: null })
      this.$emit('input', this.charge)
    },
    onDeleteShippingWeight(index) {
      this.charge[2].splice(index, 1)
    },

    saveContent: async function() {
      var vm = this
      var result = await vm.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }
      vm.loading = true
      try {
        this.$set(this.charge, 1, this.chargeStatus)
        this.$emit('input', this.charge)
        await vm.saveAllShipingCharge()
        vm.cached_charges = JSON.stringify(vm.charges)
        vm.$emit('onSave')
        vm.loading = false
        vm.isEdit = false
        await this.$nextTick()
      } catch (error) {
        console.log(error)
        vm.loading = true
      }
    },
    sendRequest: function(content, callback) {
      var vm = this
      api.updateConfig(content, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    // getAllShipingCharge: function() {
    //   var vm = this
    //   return new Promise((resolve, reject) => {
    //     api.getAllShipingCharge({ pageid: vm.selectedBot.pageid }, function(error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       let charges = Object.entries(response.shippinglist)

    //       charges = charges.map(el => {
    //         return {
    //           name: el[0],
    //           value: el[1]
    //         }
    //       })
    //       charges = charges.sort((a, b) => {
    //         if (a.name.includes('other')) {
    //           return 2
    //         } else if (b.name.includes('other')) {
    //           return -2
    //         }
    //         if (a.name.includes('cod_')) {
    //           return 1
    //         } else if (b.name.includes('cod_')) {
    //           return -1
    //         }
    //         if (a.name == b.name) {
    //           return 0
    //         } else {
    //           return a.name > b.name ? 1 : -1
    //         }
    //       })

    //       let additional_charge_index = charges.findIndex(
    //         el => el.name == 'additionalproduct_charge'
    //       )
    //       vm.additional_charge = charges[additional_charge_index]
    //       if (additional_charge_index != -1) charges.splice(additional_charge_index, 1)
    //       vm.charges = charges
    //       resolve()
    //     })
    //   })
    // },
    saveAllShipingCharge: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.charges.forEach((el, index) => {
          // default value if it is falsety
          vm.$set(vm.charges[index].value, 0, vm.charges[index].value[0] || 0)
          vm.$set(vm.charges[index].value, 3, vm.charges[index].value[3] || 0)

          if (vm.charges[index].value[2] && vm.charges[index].value[2].length > 0) {
            for (var cindex in vm.charges[index].value[2]) {
              vm.$set(vm.charges[index].value[2], cindex, {
                min: vm.charges[index].value[2][cindex].min,
                max: vm.charges[index].value[2][cindex].max,
                charge: vm.charges[index].value[2][cindex].charge
              })
            }
          }
        })

        var data = cloneDeep(vm.charges)

        data = data.reduce((prev, curr) => {
          prev[curr.name] = curr.value
          return prev
        }, {})

        data[this.name] = this.charge

        for (var item in data) {
          if (!item[0]) item[0] = 0
          if (!item[3]) item[3] = 0
        }
        data.pageid = vm.selectedBot.pageid
        api.saveAllShipingCharge(data, function(error, response) {
          if (error) {
            reject(error)
          }
          resolve()
        })
      })
    }
  },
  watch: {
    value(newVal) {
      this.charge = newVal
      if (this.name == 'cod_charge') {
        if (this.charge && this.charge[4] != '') {
          this.chargeType = 'percent'
          var percent = this.charge[4]
          try {
            percent = percent.replace('%', '')
            percent = parseInt(percent)
            this.percentCharge = percent
          } catch (error) {
            percent = 0
          }
        }
      }
    },
    chargeType(newVal) {
      if (this.name == 'cod_charge' && newVal == 'normal') {
        this.$set(this.charge, 4, '')
        this.$emit('input', this.charge)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingDetailItem.vue